// extracted by mini-css-extract-plugin
export var audioPlayer = "_sx-0";